import { Http } from '../../../support';

const initialState = {
  busy: false,
  result: undefined,
  error: undefined,
};

const submit = async (store, data) => {
  store.setState((state) => {
    state.app.retenciones.creation.busy = true;
  });

  try {
    const response = await Http.post('api/retenciones', data);

    store.setState((state) => {
      state.app.retenciones.creation = {
        ...state.app.retenciones.creation,
        busy: false,
        result: response,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.retenciones.creation = {
        ...state.app.retenciones.creation,
        busy: false,
        error: error.data || error,
      };
    });
  }
};

const resetError = (store) => (state) => {
  state.app.retenciones.creation.error = undefined;
};

const resetResult = (store) => (state) => {
  state.app.retenciones.creation.busy = false;
  state.app.retenciones.creation.result = undefined;
};

const reset = (store) => (state) => {
  state.app.retenciones.creation = {
    ...initialState,
  };
};

const actions = {
  submit,
  reset,
  resetError,
  resetResult,
};

const RetencionesCreateStore = {
  state: () => initialState,
  actions,
};

export default RetencionesCreateStore;
